module.exports = __webpack_public_path__ + "img/NO937899408.735c952c.svg";